import { Tag, Typography } from '@components';
import { Progress } from 'antd';
import React, { ReactNode, useState } from 'react';
import { Check, ChevronDown, ChevronUp } from 'react-feather';
import { GoTasklist } from 'react-icons/go';

interface SprintItemProps {
  children: ReactNode;
  title: string;
  tasks: number;
  percentage?: number;
}

export const SprintItem = ({
  title,
  children,
  tasks,
  percentage,
}: SprintItemProps) => {
  const [close, setClose] = useState(percentage === 100);

  return (
    <div
      className={`bg-gray-50 dark:bg-slate-800 rounded-xl p-6 mb-5 border ${percentage === 100 ? 'border-blue-200' : 'border-gray-50 dark:border-slate-800'}`}
    >
      <div className="flex items-center gap-4 mb-2">
        <Tag label={tasks} style="neutralcolored" icon={<GoTasklist />} />

        {percentage !== undefined && (
          <>
            <Progress
              steps={tasks}
              percent={percentage}
              strokeColor="#7BF1A8"
              size={10}
              trailColor="#BEDBFF"
            />
          </>
        )}

        <div className="ml-auto flex items-center gap-2">
          <button
            onClick={() => setClose(!close)}
            aria-label="Toggle sprint"
            className="flex items-center"
          >
            {close ? <ChevronDown /> : <ChevronUp />}
          </button>
        </div>
      </div>

      <div className="flex justify-between items-center">
        <Typography tag="h3" type="subtitle">
          {title}
        </Typography>
        {percentage === 100 && (
          <Tag
            label={'Voltooid'}
            style={'cyod'}
            lowercase
            icon={<Check size={12} />}
          />
        )}
      </div>

      {!close && <div className="mt-2">{children}</div>}
    </div>
  );
};

export default SprintItem;
